import type { ActionRewardConfig } from '~/types/loyaltyContract';

export const ACTION_REWARD_FEATURE_TOGGLE_OPTIONS = [
  { value: 'excludeIfUnenrolled', label: 'Exclude on unenrolled' },
  { value: 'cancellable', label: 'Cancellable' },
] as const;

export type ActionRewardFeatureToggle = (typeof ACTION_REWARD_FEATURE_TOGGLE_OPTIONS)[number]['value'];

type ActionRewardFeatureToggleSource = Pick<ActionRewardConfig, ActionRewardFeatureToggle>;

export function isActionRewardFeatureToggle(value: unknown): value is ActionRewardFeatureToggle {
  return ACTION_REWARD_FEATURE_TOGGLE_OPTIONS.some((option) => option.value === value);
}

export function actionRewardFeatureToggleLabel(value: ActionRewardFeatureToggle): string {
  return ACTION_REWARD_FEATURE_TOGGLE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export function getSelectedActionRewardFeatureToggles(
  config: ActionRewardFeatureToggleSource,
): Array<ActionRewardFeatureToggle> {
  return ACTION_REWARD_FEATURE_TOGGLE_OPTIONS.filter((option) => config[option.value]).map((option) => option.value);
}

export function getActionRewardFeatureToggleLabels(config: ActionRewardFeatureToggleSource): ReadonlyArray<string> {
  return getSelectedActionRewardFeatureToggles(config).map(actionRewardFeatureToggleLabel);
}
